import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/site/ProductCard";
import { PageHead } from "@/components/site/PageHead";

export default function Services() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("Tutti");
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);
  const cats = useMemo(() => ["Tutti", ...new Set(products.map((p) => p.category))], [products]);
  const list = cat === "Tutti" ? products : products.filter((p) => p.category === cat);

  return (
    <div data-testid="services-page">
      <PageHead eyebrow="Acquista online" title="Servizi &" script="prodotti" sub="Paga in anticipo in modo sicuro e presentati in officina con il tuo codice ordine." />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <div className="flex flex-wrap gap-2 mb-10" data-testid="services-filters">
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`filter-${c.toLowerCase()}`}
              className={`px-4 py-2 font-display italic uppercase font-bold tracking-wider text-sm border transition-colors duration-150 ${cat === c ? "bg-red-600 border-red-600 text-white" : "border-zinc-800 text-zinc-400 hover:border-red-600 hover:text-white"}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
        </div>
      </section>
    </div>
  );
}
